import * as angular from "angular";

export class AdminSurveyService {
    private $http: any;
    private apiRoot: string;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/admin/survey";
    }

    leaveCampaignSurvey(campaignId?: number | string): Promise<object> {
        const endpoint = campaignId
            ? "/leave_campaign_survey/" + campaignId
            : "/leave_campaign_survey";
        return this.$http.get(this.apiRoot + endpoint);
    }

    leaveCampaignSurveyResults(): Promise<object> {
        return this.$http.get(this.apiRoot + "/leave_campaign_survey_results");
    }

    submitLeaveCampaignSurvey(survey: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/submit_leave_campaign_survey/" + survey.id,
            survey
        );
    }
}

angular.module("vcServices").service("AdminSurveyService", AdminSurveyService);
